import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Observable } from 'rxjs';

@Injectable()
export class CommonModalService {

	// Default options for confirm modal
	private _confirmModalOptions: MatDialogConfig = {
		height: '200px',
		width: '480px'
	};
	constructor(
		public dialog: MatDialog
	) { }

	get confirmModalOptions() {
		return Object.assign({}, this._confirmModalOptions);
	}
	openModalWindow(modalComponent, options?: MatDialogConfig): Promise<any> {
		return new Promise((resolve, reject) => {
			options = options || {};
			// {
			// 	width: options.width || '600px',
			// 	height: options.height || '50%',
			// 	data: options.data
			// }
			const dialogRef = this.dialog.open(modalComponent, options);
			dialogRef.afterClosed()
			.catch((err) => {
				reject(err);
				return Observable.throw(err);
			})
			.subscribe((rsp) => resolve(rsp));
		});
	}

}
